import RoofPhotoUpload from "@/components/site/RoofPhotoUpload";

export default function PhotoUploadSection() {
  return (
    <section id="upload" data-testid="upload-section" className="relative py-24 md:py-32 border-t border-white/10 bg-hero-void">
      <div className="max-w-7xl mx-auto px-6">
        <RoofPhotoUpload />
      </div>
    </section>
  );
}
